import core, { View } from '@gin-betting/core';
import { persistReducer } from '@gin-betting/persist';

import type { IBettingEvents, Modules } from 'types';
import { EventType } from 'app-constants';
import type { Betslip } from 'modules/betslip';
import moduleLocator from 'moduleLocator';

const {
    utils: { measureTime },
} = core;

export const loadRestrictionModule = () =>
    import(
        /* webpackChunkName: "restrictions-module" */ '@gin-betting/restrictions'
    ).then(restrictionsModule => {
        measureTime('restrictionsModuleLoaded');

        moduleLocator.set('restrictions', restrictionsModule);

        return restrictionsModule;
    });

function handleBetslipModuleLoad(
    betslipModule: Modules['betslip']
): Modules['betslip'] {
    measureTime('betslipModuleLoaded');

    const {
        reducer,
        utils: { handleRehydrate },
        middleware,
    } = betslipModule.default;

    // eslint-disable-next-line no-param-reassign
    betslipModule.default.reducer = persistReducer<Betslip.BetslipState>(
        {
            key: 'betslip',
            whitelist: ['betslipBets', 'betslipOdds', 'oddUpdateStatus'],
            expireAfter: 1 * 60 * 60 * 1000,
            stateReconciler: (inboundState, _, reducedState) => {
                const rehydratedState = handleRehydrate(
                    reducedState,
                    inboundState
                );

                return rehydratedState.set(
                    'oddUpdateStatus',
                    inboundState.oddUpdateStatus
                );
            },
        },
        reducer
    );

    // TODO hardcode, rewrite binding bettingAPI
    betslipModule.default.middleware = () => middleware({ handleBet });

    moduleLocator.set('betslip', betslipModule);

    loadRestrictionModule();

    return betslipModule;
}

const handleBet = (bet: View.Bet): void => {
    switch (bet.declineReason) {
        case 'not_enough_balance': {
            const bettingEvents$: IBettingEvents | undefined =
                // @ts-ignore
                window.bettingAPI?.bettingEvents$;
            bettingEvents$?.dispatch(EventType.HandleNotEnoughBalance, {});
            break;
        }

        default: {
            break;
        }
    }
};

export default handleBetslipModuleLoad;
